import React from 'react';
import './ProfilePickerTitle.less';

export const ProfilePickerTitle = ({text}) => {
	return <span className="profile-picker-title">{text}</span>
}
